import React from "react";
import * as S from "./styles";
export var UpCaret = function UpCaret(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 0 15 7",
    "aria-hidden": "true",
    height: 7,
    width: 13
  }, e), React.createElement("path", {
    fillRule: "evenodd",
    d: "M343.5 35L337 41 350 41z",
    transform: "scale(-1 1) rotate(1 2173.801 -20032.514)"
  }));
};